// Misc constants. If a section grows past ~20 entries, split it into its
// own file (see query.ts, ui.ts, etc.).

export const SESSION_STORAGE_KEY = 'kaban.session';

export const API_BASE_PATH = '/api';
export const UPLOADS_BASE_PATH = '/uploads';

export const SSE_RECONNECT_BASE_MS = 1_000;
export const SSE_RECONNECT_MAX_MS = 30_000;

/**
 * Optional override host for API/SSE/upload calls.
 *
 * - Empty string (default): use relative URLs. In production nginx proxies
 *   `/api` and `/uploads`; in dev Vite's server proxy targets the backend
 *   set in `vite.config.ts`.
 * - Non-empty: prepended to every API path. Use this when running against a
 *   different host (e.g. the new modular `librecards-backend` running locally
 *   via docker compose on `http://localhost:8080`) without touching the dev
 *   proxy. Should NOT have a trailing slash.
 *
 * Configured via `VITE_API_BASE_URL` env var (see `.env.development.example`).
 */
export const API_BASE_URL: string = (() => {
  const raw = (import.meta.env?.VITE_API_BASE_URL as string | undefined) ?? '';
  return raw.replace(/\/+$/, '');
})();

/** Prefix a relative API/upload path with `API_BASE_URL` when set. */
export const withApiBase = (path: string): string => {
  if (!API_BASE_URL) return path;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
